import {
  RegisterInput,
  RegisterTaxAdvisorInput,
  RegisterUserInput,
} from '../types';
import { client } from './axiosClient';

export const registerSetupCheck = async (data: RegisterInput) => {
  const res = await client.post('/register', data);
  return res.data;
};
export const postRegisterUser = async (data: RegisterUserInput) => {
  const res = await client.post('/user-register', data);
  return res.data;
};
export const postRegisterTaxAdvisor = async (data: RegisterTaxAdvisorInput) => {
  const res = await client.post('/tax-advisor-register', data);
  return res.data;
};
